<button mat-stroked-button (click)="openDialog()" id="schedule-selector" type="button" class="item-selector tw-w-full">
  @if (scheduleSelectorService.selectedSchedules.length === 0) {
    <span class="text-muted">Select or add a new schedule</span>
  }
  @else {
    <span>{{scheduleSelectorService.selectedSchedules.length}} schedules selected</span>
  }
	<span class="text-muted tw-ml-auto"><i aria-hidden="true" class="fa fa-sort"></i></span>
</button>
